import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {en} from './en'
import {generateEnByRu} from './enAutoGenerate'
import {ru} from './ru'
import {pl} from './pl'
import {getCookie} from '../utils'

Vue.use(VueI18n)


function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item))
}

function mergeDeep(target, ...sources) {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }
  return mergeDeep(target, ...sources)
}


export const messages = {
    // en: en,
    enAutoGenerate: mergeDeep(generateEnByRu(), en),
    ru: ru,
    pl: pl
}

const i18n = new VueI18n({
    locale: getCookie('voicebotLanguage') || 'ru', // set locale
    fallbackLocale: 'enAutoGenerate', // set fallback locale
    messages // set locale messages
})

export default i18n





// WEBPACK FOOTER //
// ./client/translations/i18n.js